// removed by extract-text-webpack-plugin
module.exports = {"rippleWrapper":"_57d29118","ripple":"d1a1b1ae","rippleRestarting":"_17e5183c","rippleActive":"_3e58c4af"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/ripple/theme.css
// module id = 5258
// module chunks = 39